'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _httpRequest = require('@souche-f2e/http-request');

var _httpRequest2 = _interopRequireDefault(_httpRequest);

var _helper = require('../helper');

var _helper2 = _interopRequireDefault(_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @desc 应用宝上传 
 */
var clickId = false;
var appType = false;

var Statistics = {
    // 应用宝
    doYYBStatistics: function doYYBStatistics() {
        _httpRequest2.default.ajax({
            url: _helper2.default.SERVERURL + '/marketapi/tencentUploadApi/tencentApplicationUpload.json',
            type: 'post',
            data: {
                IMEI: appType === 'ANDROID' ? '1105722265' : '1157468974',
                appType: 'ANDROID',
                clientId: clickId
            }
        });
    }
};

exports.default = {
    init: function init(id) {
        clickId = id;
    },
    doStatistics: function doStatistics() {
        if (clickId) {
            Statistics.doYYBStatistics();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/channel/yyb.js
// module id = VZM/
// module chunks = 11